import { env } from "../datas.config";

export async function createInvitation(workspaceId, expiresAt) {
  const res = await fetch(
    `${env.domain}/api/auth/workspaces/${workspaceId}/invite`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ expiresAt }),
      credentials: "include",
    }
  );
  return res.json();
}

export async function fetchUserWorkspaces() {
  const res = await fetch(`${env.domain}/api/auth/workspaces`, {
    credentials: "include",
  });
  const data = await res.json();
  return { workspaces: data.workspaces || [], currentWorkspaceId: data.currentWorkspaceId || null };
}

export async function selectWorkspaceApi(workspaceId) {
  const res = await fetch(`${env.domain}/api/auth/workspaces/${workspaceId}/select`, {
    method: "POST",
    credentials: "include",
  });
  return res.json();
}

export async function createWorkspaceApi(nom, description) {
  const res = await fetch(`${env.domain}/api/auth/workspaces`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ nom, description }),
    credentials: "include",
  });
  return res.json();
}

export async function getInvitation(token) {
  const res = await fetch(`${env.domain}/api/auth/invite/${token}`, {
    credentials: "include",
  });
  return res.json();
}

export async function joinWorkspace(token) {
  const res = await fetch(`${env.domain}/api/auth/invite/${token}/join`, {
    method: "POST",
    credentials: "include",
  });
  return res.json();
}

export async function getWorkspaceMembres(workspaceId) {
  const res = await fetch(`${env.domain}/api/auth/workspaces/${workspaceId}/membres`, {
    credentials: "include",
  });
  return res.json();
}

export async function updateMembreRole(workspaceId, membreId, data) {
  const res = await fetch(
    `${env.domain}/api/auth/workspaces/${workspaceId}/membres/${membreId}`,
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      credentials: "include",
    }
  );
  return res.json();
}

export async function removeWorkspaceMembre(workspaceId, membreId) {
  const res = await fetch(
    `${env.domain}/api/auth/workspaces/${workspaceId}/membres/${membreId}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );
  return res.json();
}

export async function listWorkspaceFiles(workspaceId) {
  const res = await fetch(`${env.domain}/api/auth/workspaces/${workspaceId}/files`, {
    credentials: "include",
  });
  return res.json();
}

export async function uploadWorkspaceFile(workspaceId, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await fetch(`${env.domain}/api/auth/workspaces/${workspaceId}/files`, {
    method: "POST",
    body: formData,
    credentials: "include",
  });
  return res.json();
}

export async function deleteWorkspaceFile(workspaceId, fileId) {
  const res = await fetch(
    `${env.domain}/api/auth/workspaces/${workspaceId}/files/${fileId}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );
  return res.json();
}

export async function updateWorkspaceApi(workspaceId, formData) {
  const res = await fetch(
    `${env.domain}/api/auth/workspaces/${workspaceId}`,
    {
      method: "PUT",
      body: formData,
      credentials: "include",
    }
  );
  return res.json();
}

export async function deleteWorkspaceApi(workspaceId) {
  const res = await fetch(
    `${env.domain}/api/auth/workspaces/${workspaceId}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );
  return res.json();
}

export async function leaveWorkspaceApi(workspaceId) {
  const res = await fetch(
    `${env.domain}/api/auth/workspaces/${workspaceId}/leave`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );
  return res.json();
}

export async function getRagFormats() {
  const res = await fetch(`${env.domain}/api/auth/rag-formats`, {
    credentials: "include",
  });
  return res.json();
}

export async function uploadRagDocument(workspaceId, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await fetch(
    `${env.domain}/api/auth/workspaces/${workspaceId}/files/ingest`,
    {
      method: "POST",
      body: formData,
      credentials: "include",
    }
  );
  return res.json();
}

export async function listRagDocuments(workspaceId) {
  const res = await fetch(
    `${env.domain}/api/auth/workspaces/${workspaceId}/rag-documents`,
    { credentials: "include" }
  );
  return res.json();
}

export async function deleteRagDocument(workspaceId, documentId) {
  const res = await fetch(
    `${env.domain}/api/auth/workspaces/${workspaceId}/rag-documents/${documentId}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );
  return res.json();
}
